import { createContext, useCallback, useContext, useMemo, useRef } from 'react'

/** Snapshot passed client-side from signup CPF form to `/cadastro/cpf/erro` (one-shot). */
export interface CpfErrorSessionData {
  email: string | null
  cpf: string
  birthDateIso: string
}

export interface SignupFlowContextValue {
  setCpfErrorSession: (data: CpfErrorSessionData) => void
  takeCpfErrorSession: () => CpfErrorSessionData | null
}

const SignupFlowContext = createContext<SignupFlowContextValue | null>(null)

export function useSignupFlowOptional(): SignupFlowContextValue | null {
  return useContext(SignupFlowContext)
}

export function SignupFlowProvider({ children }: { children: React.ReactNode }) {
  const sessionRef = useRef<CpfErrorSessionData | null>(null)

  const setCpfErrorSession = useCallback((value: CpfErrorSessionData) => {
    sessionRef.current = value
  }, [])

  const takeCpfErrorSession = useCallback(() => {
    const current = sessionRef.current
    sessionRef.current = null
    return current
  }, [])

  const value = useMemo<SignupFlowContextValue>(
    () => ({ setCpfErrorSession, takeCpfErrorSession }),
    [setCpfErrorSession, takeCpfErrorSession]
  )

  return <SignupFlowContext.Provider value={value}>{children}</SignupFlowContext.Provider>
}
